import { render } from "./arrowIcon.vue?vue&type=template&id=05522bee&scoped=true"
import script from "./arrowIcon.vue?vue&type=script&lang=js"
export * from "./arrowIcon.vue?vue&type=script&lang=js"

import "./arrowIcon.vue?vue&type=style&index=0&id=05522bee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05522bee"]])

export default __exports__